import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const SingleBarChart = ({ ActualDaysToPay, AvgDaysAsPerTerms }) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const data = {
    labels: ['KPI'],
    datasets: [
      {
        label: 'Actual Days to Pay',
        data: [ActualDaysToPay],
        backgroundColor: 'rgba(85, 176, 99, 0.6)',
      },
      {
        label: 'Avg Days as per Terms',
        data: [AvgDaysAsPerTerms],
        backgroundColor: 'rgba(85, 176, 99, 0.6)',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false, // Show legend
        position: 'bottom', // Position the legend at the bottom
        labels: {
          boxWidth: 12, // Customize the width of the box next to the legend label
        },
      },
      datalabels: {
        display: true, // Enable data labels
        color: 'white', // Set label color to white
        font: {
          weight: 'bold',
          size: 12,
        },
        align: 'center', // Position label at the center of the bar
        anchor: 'center', // Ensure label is anchored in the middle
        formatter: (value) => value.toFixed(1), // Format the number if needed
      },
    },
    scales: {
      x: {
        ticks: {
          display: false, // Hide X-axis labels
        },
        grid: {
          drawOnChartArea: false, // Hide grid lines
          drawTicks: false, // Hide tick marks
          drawBorder: false, // Hide axis border
          color: 'white', // Set grid color to red

        },
      },
      y: {
        ticks: {
          display: false, // Hide Y-axis labels
        },
        grid: {
          drawTicks: false, // Hide tick marks
          drawBorder: false, // Hide axis border
          color: 'white', // Set grid color to red

        },
      },
    },
  };

  return (
    <div style={{ width: `${width * 0.9}px`, maxWidth: '240px', margin: '0 auto' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default SingleBarChart;
